<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
  import { provide } from 'vue'
  import { RouterView } from 'vue-router'
  import { useUserStore } from '@/stores/userStore'
  import { useAuthStore } from '@/stores/oauthStore'

  const userStore = useUserStore()
  const authStore = useAuthStore()

  provide('userStore', userStore)
  provide('authStore', authStore)
</script>

<style scoped lang="scss"></style>
